import React from 'react';
import Guide from '../../../components/Common/Guide';
import Heading from '../../../components/Common/Heading';

interface PurchaseHeaderProps {
  goBack: () => void;
}

const PurchaseHeader: React.FC<PurchaseHeaderProps> = ({ goBack }) => {
  return (
    <div className="flex justify-between items-baseline">
      <div className="flex items-center align-end mb-4">
        <Heading title="Purchase Your Book" />
        <div>
          <Guide />
        </div>
      </div>
      <button
        className="px-4 py-2 rounded-2xl bg-storyblueSecondLightText text-white font-bold text-sm"
        onClick={goBack}
      >
        Back
      </button>
    </div>
  );
};

export default PurchaseHeader;
